var reportTypeEnum = /* @__PURE__ */ ((reportTypeEnum2) => {
  reportTypeEnum2["danmaku"] = "danmaku";
  reportTypeEnum2["room"] = "room";
  reportTypeEnum2["chat"] = "chat";
  reportTypeEnum2["user"] = "user";
  reportTypeEnum2["feed"] = "feed";
  reportTypeEnum2["feedComment"] = "feed_comment";
  reportTypeEnum2["feedVoice"] = "feed_voice";
  reportTypeEnum2["videoChat"] = "video_chat";
  return reportTypeEnum2;
})(reportTypeEnum || {});
var hDtEnum = /* @__PURE__ */ ((hDtEnum2) => {
  hDtEnum2[hDtEnum2["android"] = 0] = "android";
  hDtEnum2[hDtEnum2["ios"] = 1] = "ios";
  return hDtEnum2;
})(hDtEnum || {});
var hAppEnum = /* @__PURE__ */ ((hAppEnum2) => {
  hAppEnum2["lite"] = "me-live-lite";
  hAppEnum2["pro"] = "me-live-pro";
  hAppEnum2["game"] = "me-live-game";
  hAppEnum2["higo"] = "higo";
  return hAppEnum2;
})(hAppEnum || {});
var hAreaCodeEnum = /* @__PURE__ */ ((hAreaCodeEnum2) => {
  hAreaCodeEnum2[hAreaCodeEnum2["ar"] = 0] = "ar";
  hAreaCodeEnum2[hAreaCodeEnum2["id"] = 1] = "id";
  hAreaCodeEnum2[hAreaCodeEnum2["vi"] = 2] = "vi";
  hAreaCodeEnum2[hAreaCodeEnum2["tp"] = 3] = "tp";
  hAreaCodeEnum2[hAreaCodeEnum2["ms"] = 4] = "ms";
  hAreaCodeEnum2[hAreaCodeEnum2["th"] = 5] = "th";
  hAreaCodeEnum2[hAreaCodeEnum2["hi"] = 6] = "hi";
  hAreaCodeEnum2[hAreaCodeEnum2["pk"] = 7] = "pk";
  hAreaCodeEnum2[hAreaCodeEnum2["tr"] = 8] = "tr";
  hAreaCodeEnum2[hAreaCodeEnum2["hk"] = 9] = "hk";
  return hAreaCodeEnum2;
})(hAreaCodeEnum || {});
var hLanguageEnum = /* @__PURE__ */ ((hLanguageEnum2) => {
  hLanguageEnum2["en"] = "en";
  hLanguageEnum2["ar"] = "ar";
  hLanguageEnum2["id"] = "id";
  hLanguageEnum2["th"] = "th";
  hLanguageEnum2["vi"] = "vi";
  hLanguageEnum2["tr"] = "tr";
  hLanguageEnum2["ms"] = "ms";
  hLanguageEnum2["hk"] = "hk";
  hLanguageEnum2["zh"] = "zh";
  hLanguageEnum2["hi"] = "hi";
  hLanguageEnum2["test"] = "test";
  return hLanguageEnum2;
})(hLanguageEnum || {});
export {
  hAppEnum,
  hAreaCodeEnum,
  hDtEnum,
  hLanguageEnum,
  reportTypeEnum
};
